import {get, post} from "@/utils/http"

export const _selectPages = params => get("/weixinLoginUser/selectPages",params);

export const _get = params => get("/weixinLoginUser/get?",params);

export const _edit = params => post("/weixinLoginUser/update",params);

export const _updateStatus = params =>get("/weixinLoginUser/updateStatus?",params);

export const _delete = params =>get("/weixinLoginUser/delete?",params);
